import React from 'react';
import { styled } from '@mui/material/styles';
import {useTranslation} from 'react-i18next';
import {
  Typography,
  TableCell,
  Chip,
} from '@mui/material';


import {ROW_HEIGHT} from './TableContainerComponent';
import {UserRole,RequestStatusId} from '../../../ApplicationConfig/constants'
import {UserInfoContext} from '../../../StateObjects/UserInfoContext';

const PREFIX = 'AnalystCell';

const classes = {
  tablesCellsFlex: `${PREFIX}-tablesCellsFlex`,
  leadChip: `${PREFIX}-leadChip`
};

const StyledTableCell = styled(TableCell)((
  {
    theme
  }
) => ({
  [`&.${classes.tablesCellsFlex}`]: {
    display: 'flex',
    alignItems: 'center',
    minHeight: `calc(${ROW_HEIGHT}px - ${theme.spacing(2)})`,
  },

  [`& .${classes.leadChip}`]: {
    paddingRight: theme.spacing(1),
    marginRight: theme.spacing(1),
    borderRight: '1px solid',
    borderRightColor: theme.palette.divider,
  }
}));

export default function AnalystCell(props) {
  const { 
    leadAnalyst,
    supportAnalysts,
    toggleManageTeamDrawer,
    clickHandler,
    row
  } = props;
  const extraAnalysts = supportAnalysts.length;
  

  const {t} = useTranslation();
  const {userInfo} = React.useContext(UserInfoContext);

  const handleClick = (e) => {
    e.stopPropagation();
    if (userInfo.role === UserRole.Analyst) {
      if (row.status.id === RequestStatusId.Approved || row.status.id === RequestStatusId.Denied) {
        clickHandler(e);
      } else {
        toggleManageTeamDrawer(null,row);
      }
    }
  };

  if (userInfo.role === UserRole.Researcher) {
    
    if(leadAnalyst.account.length>0){
      return (
        <StyledTableCell className={classes.tablesCellsFlex}>
          <Chip label={leadAnalyst.fullName} onClick={clickHandler} />
          
          </StyledTableCell>
      );
    }
    else
    {
      return (<StyledTableCell className={classes.tablesCellsFlex} >
        <Typography variant="body2" color="textSecondary">{t('researcherDashboard.analystCell.labelUnassigned')}</Typography>
        </StyledTableCell>)
    }
    
  } else if (userInfo.role === UserRole.Analyst) {

    if (leadAnalyst.account.length>0 && supportAnalysts.length > 0) {
      return (
        <StyledTableCell className={classes.tablesCellsFlex}>
          <Chip label={leadAnalyst.fullName} 
           onClick={handleClick}
            sx={{mr: 1}}/>

          <Chip label={`${extraAnalysts} ${t('analystDashboard.labelSupport')}`} onClick={handleClick} />
          
        </StyledTableCell>
      );
    } else if (leadAnalyst.account.length===0 && supportAnalysts.length>0) {
      return (
        <StyledTableCell className={classes.tablesCellsFlex}>
          <Typography variant="body2" color="textSecondary">{t('analystDashboard.labelNoLead')}</Typography>
          <Chip label={`${extraAnalysts} ${t('analystDashboard.labelSupport')}`} onClick={handleClick}
             sx={{ml: 1}} />
       
      </StyledTableCell>
      );
    } 
    else if (leadAnalyst.account.length===0) {
     return(<StyledTableCell className={classes.tablesCellsFlex} ><Typography variant="body2" color="textSecondary">{t('analystDashboard.analystCell.labelUnassigned')}</Typography></StyledTableCell>);
    }
    else if (leadAnalyst.account.length > 0) {
      return (
        <StyledTableCell className={classes.tablesCellsFlex}>
          <Chip label={leadAnalyst.fullName} 
            onClick={handleClick}
            sx={{mr: 1}}/>
        
        </StyledTableCell>
      );
    }
  }
}